// extracted by mini-css-extract-plugin
export default {"root":"FloatingCard-root","oneApproot":"FloatingCard-oneApproot","container":"FloatingCard-container","form":"FloatingCard-form","oneAppContainer":"FloatingCard-oneAppContainer"};